import { Link } from "react-router-dom";
import { Text } from "./typography";
import { IconChevronRight } from "@tabler/icons-react";
export interface BreadcrumbItem {
    label: string;
    path?: string;
}
interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}
export function Breadcrumbs({ items }: BreadcrumbsProps) {
    return (<nav className="flex items-center gap-2 mb-6 print:hidden">
      {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (<div key={index} className="flex items-center gap-2">
            {item.path && !isLast ? (<Link to={item.path} className="hover:opacity-80 transition-opacity">
                <Text variant="body" tone="body">
                  {item.label}
                </Text>
              </Link>) : (<Text variant="body">
                {item.label}
              </Text>)}
            {!isLast && (<IconChevronRight size={16} style={{
                        color: "#6B7280"
                    }}/>)}
          </div>);
        })}
    </nav>);
}
